import type { ReactNode } from 'react';

import styles from './StateMessage.module.css';

export interface EmptyStateProps {
  title: string;
  description?: string | undefined;
  /** Decorative glyph or illustration; hidden from assistive technology. */
  icon?: ReactNode | undefined;
  action?: ReactNode | undefined;
  className?: string | undefined;
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div className={[styles.state, className].filter(Boolean).join(' ')}>
      <span className={styles.icon} aria-hidden="true">
        {icon ?? '∅'}
      </span>
      <p className={styles.title}>{title}</p>
      {description !== undefined ? <p className={styles.description}>{description}</p> : null}
      {action !== undefined ? <div className={styles.actions}>{action}</div> : null}
    </div>
  );
}
